import React from 'react';
import { List } from 'semantic-ui-react'
// import {graphql} from 'react-apollo';

//utils
// import queries from '../../../src/utils/queries'

import TitDer from '../../../components/funcionales/titder';
import general from '../../../modulos/general';

//Procesos DX
const DetalleNivel1 = ({styles, elemento, handleClickidLista}) => {
  return(
    <tr className=''  onClick={(ev)=>handleClickidLista(ev, elemento)}>
      <td className=''>{elemento.numeroOdeDX}</td>
      <td className=''>{elemento.fechaRef.substr(0, 10)}</td>
      <td className=''>{elemento.diasMora} días</td>
      <td className=''>{elemento.porcMovim}%</td>
      <td className=''>{general.formatNum(elemento.valorMovim.toString())}</td>
      <td className='' style={{color: elemento.estadoProcDX==='ABIERTA'?'yellow':'#93291E', fontWeight: 'bold'}}>{elemento.estadoProcDX}</td>
    </tr>
  )
};

const Lista = ({styles, list, handleClickidLista}) => {
  const nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento} styles={styles}
    handleClickidLista={handleClickidLista} key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

const ProcCliDX2 = ({styles, handleClick, list, handleClickidLista}) => {
  return (
    <div>
      <List selection>
        <TitDer list={list} textBoton1="Procesos DX" btnNuevo="NO" styles={styles} handleClick={handleClick} />
        <div>
          <table className='ui blue inverted celled selectable table' style={styles.styTableSup}>
            <thead className=''>
              <tr className=''>
                <th className='' style={{width: '10%'}}>DX No.</th>
                <th className='' style={{width: '10%'}}>Fecha</th>
                <th className='' style={{width: '15%'}}>Mora mayor o igual a</th>
                <th className='' style={{width: '35%'}}>Saldo mayor o igual a XX% del valor del movim</th>
                <th className='' style={{width: '20%'}}>Saldo mayor o igual a</th>
                <th className='' style={{width: '10%'}}>Estado</th>
              </tr>
            </thead>
            <Lista list={list} handleClickidLista={handleClickidLista}/>
          </table>
          <p></p>
        </div>
      </List> 
    </div>
  )
};

export default ProcCliDX2
